module.exports.fluidSlotDefinitions = [];